angular.module('homebot.directives')

.directive('anchor', ['$timeout', 'ScrollService', '$location', function($timeout, ScrollService, $location){
  return {
    restrict: 'E',
    controllerAs: 'anchorCtrl',
    bindToController: {
      onFocus: '&',
      hash: '@',
    },
    scope: {},
    controller: function(){ },
    link: function(scope, el, attrs, ctrl){

      ctrl.runOnLoad = function(){
        let target;

        if($location.hash())
          target = $location.hash();
        else if($location.search().section)
          target = $location.search().section;

        $timeout(() => { ctrl.scrollPage(target); }, 1200);
      };

      ctrl.runOnHashChange = function(){
        ScrollService.subscribe(scope, (e, data) => {
          ctrl.scrollPage(data.target);
        });
      };

      ctrl.scrollPage = function(target){
        if(target !== ctrl.hash) return;

        const scrollAdjustment = window.outerHeight / 20;
        const scrollTop = el[0].getBoundingClientRect().top - scrollAdjustment;

        $('html, body').animate({scrollTop: document.body.scrollTop + scrollTop}, function(){
          if(ctrl.onFocus)
            ctrl.onFocus();

          scope.$apply();
        });
      };

      ctrl.runOnLoad();
      ctrl.runOnHashChange();
    },
  };
}]);
